import NProgress from "nprogress";
import "nprogress/nprogress.css";

window.NProgress = NProgress;
